<template>
  <div class="dictselect">
    <el-select
      v-if="dictCode == 'province_code'"
      v-model="value"
      :placeholder="placeholder"
      @change="selectchange($event)"
      size="small"
    >
      <el-option
        v-for="item in options"
        :key="item.description"
        :label="item.label"
        :value="item.description"
      >
      </el-option>
    </el-select>
    <el-select
      v-else
      v-model="value"
      :placeholder="placeholder"
      @change="selectchange($event)"
      size="small"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { ajaxGetDictItems } from "@/api/api";
export default {
  props: {
    dictCode: {
      type: String,
      require: true,
    },
    placeholder: {
      type: String,
    },
    modelvalue: [String, Number],
  },
  data() {
    return {
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      value: "",
    };
  },
  model: {
    props: "modelvalue",
    event: "change",
  },
  watch: {
    modelvalue(newval, oldval) {
      // this.value = newval;
      // console.log(oldval, oldval);
    },
  },
  created() {
    this.initDictData();
  },
  methods: {
    initDictData() {
      ajaxGetDictItems(this.dictCode).then((res) => {
        // console.log(res);
        if (res.success) {
          this.options = res.result;
        }
        // console.log(this.modelvalue);
      });
    },
    selectchange(e) {
      // console.log(e);
      this.$emit("change", e);
    },
  },
};
</script>
<style lang="less" scoped></style>
